import styled from "styled-components";

export const StyledHeaderLogo = styled.div`
	@media (max-width: 768px) {
		order: 1;
		flex: 1 1 20%;
	}
`;
